import { useState, useEffect } from 'react';

interface IframeMessage {
  type: 'PARTIU_HIDE_CHROME' | 'PARTIU_SHOW_CHROME';
}

export function useIframePostMessage() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = event.data as IframeMessage;
      if (!data || typeof data !== 'object' || typeof data.type !== 'string') return;

      if (data.type === 'PARTIU_HIDE_CHROME') {
        setIsFullscreen(true);
      } else if (data.type === 'PARTIU_SHOW_CHROME') {
        setIsFullscreen(false);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return { isFullscreen };
}
